import { Dropdown, FormLayout, TagInput, TextInput } from 'components/common'
import { CommonFormType, activeOptions, aggregatorFormFields } from '../utils'

const {
  AGG_ID,
  AGG_IS_ACTIVE,
  AGG_NAME,
  AGG_GRUBTECH_ID,
  AUTO_ATTACH_BARCODES,
} = aggregatorFormFields

type AggregatorDetailsFormType = {
  isUpdate?: boolean
} & CommonFormType

function AggregatorDetailsForm({
  register,
  errors,
  setValue,
  isUpdate = false,
  aggregator,
}: AggregatorDetailsFormType) {
  return (
    <>
      <div className="mb-1 flex items-start justify-between gap-5">
        <h3 className="title">Aggregator Details</h3>

        {/* Aggregator Active/Inactive */}
        <div className="w-full max-w-32">
          <Dropdown
            defaultValue={aggregator?.isActive ?? true}
            setValue={setValue}
            options={activeOptions}
            name={AGG_IS_ACTIVE.key}
            error={errors?.[AGG_IS_ACTIVE.key]?.message as string}
          />
        </div>
      </div>

      <FormLayout>
        <div className="flex flex-col gap-5">
          <div className="gap-5 mid-md:flex">
            {/* Aggregator ID */}
            <TextInput
              required={!isUpdate}
              disabled={isUpdate}
              register={register}
              name={AGG_ID.key}
              label={AGG_ID.label}
              error={errors?.[AGG_ID.key]?.message as string}
            />

            {/* Aggregator Name */}
            <TextInput
              required={!isUpdate}
              register={register}
              name={AGG_NAME.key}
              label={AGG_NAME.label}
              error={errors?.[AGG_NAME.key]?.message as string}
            />
            <TextInput
              required={false}
              register={register}
              name={AGG_GRUBTECH_ID.key}
              label={AGG_GRUBTECH_ID.label}
              error={errors?.[AGG_GRUBTECH_ID.key]?.message as string}
            />
          </div>

          <TagInput
            name={AUTO_ATTACH_BARCODES.key}
            label={AUTO_ATTACH_BARCODES.label}
            setValue={setValue}
            defaultValue={aggregator?.autoAttachBarcodes ?? []}
            error={errors?.[AUTO_ATTACH_BARCODES.key]?.message as string}
            hintText="These barcodes will be automatically added as products to every order received from this aggregator."
          />
        </div>
      </FormLayout>
    </>
  )
}

export default AggregatorDetailsForm
